<template>
  <footer class='ahc-lifetime-footer' v-show="this.isAnimating === false">
    <div class='ahc-lifetime-footer_logos'>
      <img
        src="../assets/lifetime-logo-footer.svg"
        class='ahc-lifetime-footer_lifetime-logo'
        alt="Lifetime footer logo"
      />
      <div class='ahc-lifetime-footer_powered-by'>
        Powered by <strong>Gallagher</strong>
      </div>
    </div>
    <div class="ahc-lifetime-footer_links">
      <button @click="showDisclaimerPage()">
        Disclaimer and Assumptions
      </button>
    </div>
  </footer>
</template>

<script>
import { mapMutations } from 'vuex';
import { mapFields } from "vuex-map-fields";

export default {
  computed: {
    ...mapFields([
      'ui.showForeground',
      'ui.isAnimating',
    ]),
  },
  methods: {
    ...mapMutations([
      'goToPage',
    ]),
    showDisclaimerPage() {
      // Toggle scene on explicitly as disclaimer page can be visited with the foreground still hidden, which feels like broken functionality.
      this.showForeground = true;
      this.goToPage('disclaimer-and-assumptions');
    }
  }
}
</script>

<style lang='scss'>

.ahc-lifetime-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.25rem 0.375rem;
  font-size: 0.7rem;
  transform: translateY(-100%);
  background: rgba(255,255,255,0.6);
}

.ahc-lifetime-footer_logos {
  flex: 1;
  display: flex;
  align-items: center;
  text-decoration: none;
}

.ahc-lifetime-footer_powered-by {
  margin-left: 0.5rem;
  color: #1d1d1b;
}

.ahc-lifetime-footer_lifetime-logo {
  height: 30px;
}

.ahc-lifetime-footer_links {

  button {
    appearance: none;
    margin: 0 0.375rem;
    padding: 0;
    font-size: 1em;
    background: transparent;
    border: 0 none;
    color: inherit;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
